var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7035 8.45656L7.8535 5.6224L5.621 7.8549L8.45516 10.6891L10.7035 8.45656ZM1.5835 17.4182H6.3335V20.5849H1.5835V17.4182ZM17.4168 1.66406H20.5835V6.3349H17.4168V1.66406ZM30.1468 5.61448L32.3762 7.84223L29.542 10.6764L27.3142 8.44706L30.1468 5.61448ZM27.2968 29.5466L30.131 32.3966L32.3635 30.1641L29.5135 27.3299L27.2968 29.5466ZM31.6668 17.4182H36.4168V20.5849H31.6668V17.4182ZM19.0002 9.50156C13.7593 9.50156 9.50016 13.7607 9.50016 19.0016C9.50016 24.2424 13.7593 28.5016 19.0002 28.5016C24.241 28.5016 28.5002 24.2424 28.5002 19.0016C28.5002 13.7607 24.241 9.50156 19.0002 9.50156ZM19.0002 25.3349C15.501 25.3349 12.6668 22.5007 12.6668 19.0016C12.6668 15.5024 15.501 12.6682 19.0002 12.6682C22.4993 12.6682 25.3335 15.5024 25.3335 19.0016C25.3335 22.5007 22.4993 25.3349 19.0002 25.3349ZM17.4168 31.6682H20.5835V36.3391H17.4168V31.6682ZM5.621 30.1482L7.8535 32.3807L10.6877 29.5307L8.45516 27.2982L5.621 30.1482Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/morning.c1f5c08e603a6d69298de804d2da2c5c.svg";
export { ForwardRef as ReactComponent };